const pdpLinkClickMapper = require('../../cards/detail/product/atm-mapper-pdp-link-click');

function ProductReviewHeadingDirective(GlobalHeaderPanelService, breakpointsService, $state, $timeout, bwsNotificationService, atm) {
	return {
		restrict: 'E',
		template: require('./product-review-heading-template.html'),
		require: '^wowReviewOverview',
		scope: {
			title: '@'
		},
		link(scope, element, attr, ctrl) {

			scope.overall = ctrl.overall;
			scope.user = ctrl.user;

			const writeReviewAnalytics = () => {
				atm.push({
					linkName: `web:pdp:write a review`,
					linkType: 'pdp reviews'
				}, pdpLinkClickMapper);
			};

			scope.switchToAdding = () => {
				ctrl.isAddingReview = true;
				writeReviewAnalytics();
			};

			scope.hasReviews = () => {
				return ctrl.reviews.length > 0;
			};

			scope.signIn = () => {
				writeReviewAnalytics();
                if (breakpointsService.isInSmallFormat) {
                    $state.go('shop.authentication.login');
                } else {
					GlobalHeaderPanelService.openPanel(GlobalHeaderPanelService.panels.login);
					ctrl.isAddingReview = true;
                }

                if (scope.user.isGuest) {
                    $timeout(function () {
                        bwsNotificationService.info('You need to login or register to write a review');
                    }, 2000);
                }
            };
		}
	};
}

module.exports = ProductReviewHeadingDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/headings/product-review-heading-directive.js
 **/